var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsDetail"},[_c('div',{staticClass:"headImg"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":`http://www.china-tillage.com:8000${_vm.headImg}`,"alt":""}})]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v(" 新闻详情 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }